import * as MQ from 'styles/media-queries'

export const MQ_MAPPINGS = {
  desktop: MQ.DESKTOPS,
  tablet: MQ.TABLETS,
  '!tablet': MQ.NOT_TABLETS,
  phone: MQ.PHONES,
  '!phone': MQ.NOT_PHONES,
}

export const AVAILABLE_PROPS = [
  'lr',
  'tb',
  'all',
  'left',
  'right',
  'top',
  'bottom',
]

export const SIDES = {
  all: ['left', 'right', 'top', 'bottom'],
  lr: ['left', 'right'],
  tb: ['top', 'bottom'],
  top: ['top'],
  left: ['left'],
  right: ['right'],
  bottom: ['bottom'],
}
